import HeaderFooterWrapper from "./header-footer-wrapper";

// Logs when the client route changes
export const onRouteUpdate = ({ location }) => {
  const body = window.document.body;

  if (
    /room\/details/.test(location.pathname) ||
    /create-room/.test(location.pathname)
  ) {
    body.setAttribute("data-hide-header", "false");
    body.setAttribute("data-hide-footer", "false");
  } else if (/room/.test(location.pathname)) {
    body.setAttribute("data-hide-header", "true");
    body.setAttribute("data-hide-footer", "true");
  } else {
    body.setAttribute("data-hide-header", "false");
    body.setAttribute("data-hide-footer", "false");
  }
};

export const onInitialClientRender = () => {
  document.body.setAttribute("design-your-home", "true");
  document.body.setAttribute("data-wrapper-test", "none");
};

export const wrapRootElement = HeaderFooterWrapper;
